import { Avatar } from "@material-ui/core";
import { Rating } from "@material-ui/lab";
import React from "react";
import moment from "moment";
import { s3baseUrl } from "../../../../bl_libs/invokeApi";

function ReviewProfile(props) {
  const { review_array } = props;

  console.log(review_array, "review_array");
  return (
    <>
      <div
        className="heading-wrapper black-bg text-center"
        style={{ width: "100%" }}
      >
        <span>
          <h6 className="text-white">Reviews</h6>
        </span>
      </div>
      <div className="rounded-box profile-review scrolling">
        <div className="request-left-box p-3 p-sm-4 ">
          {/*  */}
          {review_array.length > 0 &&
            review_array.map((review) => (
              <div className="comment-box">
                <div className="row">
                  <div className="col-3 col-sm-1  ">
                    <div className="profile-pic-small">
                      {review.customer_profile.profile_picture ? (
                        <img
                          src={
                            s3baseUrl + review.customer_profile.profile_picture
                          }
                          style={{ width: 60, height: 60 }}
                          className="rounded-circle circle-box circle-box-small"
                        />
                      ) : (
                        <Avatar style={{ width: 60, height: 60 }}>
                          {review.customer_profile.first_name[0].toUpperCase()}
                        </Avatar>
                      )}
                    </div>
                  </div>
                  <div className="col-9 col-sm-11">
                    <div className="sub-title">
                      <span className="pr-2 align-middle pl-md-3 pl-xl-0">
                        {review.customer_profile.first_name +
                          " " +
                          review.customer_profile.last_name}
                      </span>
                      {/* <img src={startRatingImage} /> */}
                      <Rating
                        className="align-bottom"
                        value={review.review_array.company_rating}
                        precision={0.1}
                        readOnly
                      />
                    </div>
                    <div className="request-date-line caption light-grey-color pt-1 pb-3">
                      <div className="row">
                        {/* <div className="col-12 col-sm-3 pr-sm-0">
                    Request #{request_id}
                  </div> */}
                        <div className="col-12 col-sm-12 pl-sm-0 pl-md-4 pl-xl-3">
                          {moment(review.review_array.created_at).format("LLL")}
                        </div>
                      </div>
                    </div>
                    <div className="small-font-size">
                      <p className="mb-2">
                        {review.review_array.company_comment}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
}

export default ReviewProfile;
